/**
 * @fileoverview Unlock code modal component.
 * ToddlerGame.setupPremiumUI() wires up handlers to the child element IDs,
 * so this must be mounted before that method runs.
 */

import { render } from 'preact';

function UnlockModal() {
    return (
        <div class="unlock-modal-content">
            <h2>Enter Unlock Code</h2>
            <p>Enter your 16-character unlock code:</p>
            <input
                type="text"
                id="unlockCodeInput"
                placeholder="XXXX-XXXX-XXXX-XXXX"
                maxLength={19}
            />
            <div class="unlock-modal-buttons">
                <button class="cancel-button" id="unlockModalCancel">Cancel</button>
                <button class="submit-button" id="unlockModalSubmit">Unlock</button>
            </div>
        </div>
    );
}

export function mountUnlockModal(): void {
    const el = document.getElementById('unlockModal');
    if (!el) return;
    render(<UnlockModal />, el);
}
